module.exports = __webpack_public_path__ + "static/media/loginInfo_blue.3fe9b9a3.svg";